import { PERMISSIONS } from '@conversed/shared/src/central/constants/permissions';
import { PreviewConfigsSchema } from '@conversed/shared/src/central/types/preview';
import { createRESTContract } from '../../index';

const { WEBCLIENT } = PERMISSIONS;

export const previewContract = createRESTContract({
  getPreviewConfigs: {
    method: 'GET',
    path: '/preview',
    permissions: [WEBCLIENT.WEBCLIENT_PREVIEW],
    response: PreviewConfigsSchema,
  },
  updatePreviewConfigs: {
    method: 'PUT',
    path: '/preview',
    permissions: [WEBCLIENT.WEBCLIENT_PREVIEW],
    body: PreviewConfigsSchema,
    response: PreviewConfigsSchema,
  },
});
